(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    /* ---------- Panels: switch group unless the pointer is heading to the panel ---------- */
  if (!customElements.get('cacles-mega')) {
    class CaclesMega extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-cm-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-cm-panel]'));
        this.panelsBox = this.querySelector('.cm__panels');
        this.points = [];
        this.lastMove = 0;
        this.pending = null;
        this.timer = null;

        this.addEventListener('pointermove', (e) => {
          this.points.push({ x: e.clientX, y: e.clientY });
          if (this.points.length > 4) this.points.shift();
          this.lastMove = performance.now();
        });

        this.tabs.forEach((tab) => {
          tab.addEventListener('pointerenter', () => this.request(tab));
          tab.addEventListener('focus', () => this.activate(tab));
        });

        this.panelsBox?.addEventListener('pointerenter', () => this.cancel());
        this.addEventListener('pointerleave', () => this.cancel());
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      cancel() {
        clearTimeout(this.timer);
        this.pending = null;
      }

      request(tab) {
        clearTimeout(this.timer);
        this.pending = tab;

        if (!this.aiming()) {
          this.activate(tab);
          return;
        }

        this.timer = setTimeout(() => {
          if (this.pending !== tab) return;
          if (!tab.matches(':hover')) {
            this.pending = null;
            return;
          }
          if (performance.now() - this.lastMove > 100 || !this.aiming()) {
            this.activate(tab);
          } else {
            this.request(tab);
          }
        }, 220);
      }

      aiming() {
        if (!this.panelsBox || this.points.length < 2) return false;

        const rect = this.panelsBox.getBoundingClientRect();
        const cur = this.points[this.points.length - 1];
        const prev = this.points[0];

        if (cur.x >= rect.left || prev.x >= cur.x) return false;

        const upper = { x: rect.left, y: rect.top - 40 };
        const lower = { x: rect.left, y: rect.bottom + 40 };
        const slope = (a, b) => (b.y - a.y) / (b.x - a.x);

        return slope(cur, upper) < slope(prev, upper) && slope(cur, lower) > slope(prev, lower);
      }

      activate(tab) {
        this.pending = null;
        const id = tab.dataset.cmTab;
        this.tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.cmTab === id));
        this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.cmPanel === id));
      }
    }

    customElements.define('cacles-mega', CaclesMega);
  }

  /* ---------- Top bar: hover intent (delayed close, delayed switch) ----------
     Horizon closes instantly on pointerleave and re-dispatches pointerenter on idle.
     Every enter/leave on a top item while a dropdown is open is held here and
     resolved after a short delay, based on what is really under the pointer. */
  if (!window.__caclesMenuIntent) {
    window.__caclesMenuIntent = true;

    const ITEM = 'header-menu .menu-list__list-item:not([slot="overflow"])';
    const CLOSE_DELAY = 300;
    const SWITCH_DELAY = 80;
    const AIM_DELAY = 320;
    const trail = [];
    let passing = false;
    let timer = null;

    window.addEventListener('pointermove', (e) => {
      if (e.pointerType === 'touch') return;
      trail.push({ x: e.clientX, y: e.clientY });
      if (trail.length > 6) trail.shift();
    }, { passive: true });

    // Pointer moving down (straight or diagonal), not sideways along the bar
    const headingDown = () => {
      if (trail.length < 3) return false;
      const a = trail[0];
      const b = trail[trail.length - 1];
      const dy = b.y - a.y;
      return dy > 3 && dy >= Math.abs(b.x - a.x) * 0.35;
    };

    const isOpen = (li) => !!li.querySelector(':scope > .menu-list__link[aria-expanded="true"]');
    const itemsOf = (menu) => Array.from(menu.querySelectorAll(ITEM));

    // Send the event to Horizon once the intent is clear
    const pass = (li, type) => {
      passing = true;
      li.dispatchEvent(new PointerEvent(type, { pointerType: 'mouse' }));
      passing = false;
    };

    // Decide based on what is under the pointer right now
    const resolve = (menu) => {
      timer = null;
      const items = itemsOf(menu);
      const open = items.find(isOpen);
      const hovered = items.find((item) => item.matches(':hover'));

      if (hovered) {
        if (hovered !== open) pass(hovered, 'pointerenter');
        return;
      }
      if (open) pass(open, 'pointerleave');
    };

    const schedule = (menu, delay) => {
      clearTimeout(timer);
      timer = setTimeout(() => resolve(menu), delay);
    };

    const guard = (e) => {
      if (passing || e.pointerType === 'touch') return;

      const li = e.target;
      if (!(li instanceof Element) || !li.matches(ITEM)) return;

      const menu = li.closest('header-menu');
      if (!menu) return;

      const open = itemsOf(menu).find(isOpen);
      if (!open) return; // nothing open: Horizon opens instantly

      // Back on the open item (or its dropdown): keep it, cancel any pending close
      if (e.type === 'pointerenter' && li === open) {
        clearTimeout(timer);
        timer = null;
        return;
      }

      e.stopImmediatePropagation();

      if (e.type === 'pointerleave') {
        schedule(menu, CLOSE_DELAY);
      } else {
        schedule(menu, headingDown() ? AIM_DELAY : SWITCH_DELAY);
      }
    };

    window.addEventListener('pointerenter', guard, true);
    window.addEventListener('pointerleave', guard, true);
  }

  /* ---------- Menu thumbnails: download them all once the menu bar is touched ---------- */
  if (!window.__caclesMenuImages) {
    window.__caclesMenuImages = true;

    const loadAll = (menu) => {
      if (menu.dataset.cmImagesLoaded) return;
      menu.dataset.cmImagesLoaded = 'true';

      menu.querySelectorAll('img[data-cm-src]').forEach((img) => {
        if (img.dataset.cmSrcset) img.srcset = img.dataset.cmSrcset;
        img.src = img.dataset.cmSrc;
        img.removeAttribute('data-cm-src');
        img.removeAttribute('data-cm-srcset');
      });
    };

    const onIntent = (e) => {
      if (!(e.target instanceof Element)) return;
      const menu = e.target.closest('header-menu');
      if (menu) loadAll(menu);
    };

    window.addEventListener('pointerover', onIntent, { passive: true });
    window.addEventListener('focusin', onIntent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cacles-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cacles-countdown')) {
    class CaclesCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) || 0;
        this.days = this.dataset.days !== 'false';
        this.nodes = {};
        this.querySelectorAll('[data-u]').forEach((node) => {
          this.nodes[node.dataset.u] = node;
        });
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const left = this.end - Date.now();
        if (left <= 0) {
          clearInterval(this.timer);
          this.finish();
          return;
        }

        const total = Math.floor(left / 1000);
        const d = Math.floor(total / 86400);
        const h = Math.floor((total % 86400) / 3600) + (this.days ? 0 : d * 24);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;

        this.set('d', d);
        this.set('h', h);
        this.set('m', m);
        this.set('s', s);
      }

      set(unit, value) {
        const node = this.nodes[unit];
        if (!node) return;
        const text = String(value).padStart(2, '0');
        if (node.textContent !== text) node.textContent = text;
      }

      finish() {
        const time = this.querySelector('.ccd__time');
        const expired = this.querySelector('.ccd__expired');

        if (this.dataset.mode === 'text') {
          if (time) time.hidden = true;
          if (expired) expired.hidden = false;
        } else if (!window.Shopify?.designMode) {
          this.hidden = true;
        }
      }
    }

    customElements.define('cacles-countdown', CaclesCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["klarna-installments"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klarna-installments')) {
    class KlarnaInstallments extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-klarna-json]');
        if (!json) return;
        try {
          this.data = JSON.parse(json.textContent);
        } catch (err) {
          console.error('klarna-installments: JSON inválido', err);
          return;
        }

        this.amount = this.querySelector('[data-amount]');
        this.fmt = new Intl.NumberFormat(this.data.locale || 'es-ES', {
          style: 'currency',
          currency: this.data.currency || 'EUR'
        });
        this.section = this.closest('.shopify-section') || document;

        this.onVariant = (e) => this.update(e?.detail?.resource?.id);
        this.onChange = () => {
          requestAnimationFrame(() => this.update());
          setTimeout(() => this.update(), 350);
        };

        document.addEventListener('variant:update', this.onVariant);
        this.section.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
        this.section?.removeEventListener('change', this.onChange);
      }

      currentId() {
        return Number(
          this.section.querySelector('form input[name="id"]')?.value ||
          new URL(location.href).searchParams.get('variant')
        );
      }

      update(id) {
        const variantId = Number(id) || this.currentId();
        const price = this.data.prices[variantId];
        if (price == null) return;

        const show = price >= this.data.min && price <= this.data.max;
        if (this.hidden === show) this.hidden = !show;
        if (!show) return;

        const text = this.fmt.format(Math.floor(price / this.data.n) / 100);
        if (this.amount && this.amount.textContent !== text) this.amount.textContent = text;
      }
    }

    customElements.define('klarna-installments', KlarnaInstallments);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["low-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('low-stock')) {
    class LowStock extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-stock-json]');
        if (!json) return;
        try {
          this.data = JSON.parse(json.textContent);
        } catch (err) {
          console.error('low-stock: JSON inválido', err);
          return;
        }

        this.card = this.querySelector('[data-card]');
        this.badge = this.querySelector('[data-badge]');
        this.text = this.querySelector('[data-text]');
        this.fill = this.querySelector('[data-fill]');
        this.section = this.closest('.shopify-section') || document;

        this.onVariant = (e) => this.update(e?.detail?.resource?.id);
        this.onChange = () => {
          requestAnimationFrame(() => this.update());
          setTimeout(() => this.update(), 350);
        };

        document.addEventListener('variant:update', this.onVariant);
        this.section.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
        this.section?.removeEventListener('change', this.onChange);
      }

      currentId() {
        return Number(
          this.section.querySelector('form input[name="id"]')?.value ||
          new URL(location.href).searchParams.get('variant') ||
          this.data.initial
        );
      }

      renderText(qty) {
        const d = this.data;
        this.text.replaceChildren();

        if (!d.showNumber) {
          this.text.textContent = d.textHidden;
          return;
        }

        const tpl = qty === 1 ? d.textOne : d.textMany;
        const parts = tpl.split('{qty}');
        parts.forEach((part, i) => {
          if (part) this.text.append(document.createTextNode(part));
          if (i < parts.length - 1) {
            const strong = document.createElement('strong');
            strong.textContent = qty;
            this.text.append(strong);
          }
        });
      }

      update(id) {
        const d = this.data;
        const variantId = Number(id) || this.currentId();
        const v = d.variants[variantId];
        const show = v && v.t && v.q > 0 && v.q <= d.threshold;

        if (!show) {
          if (!this.card.hidden) this.card.hidden = true;
          return;
        }

        const critical = v.q <= d.critical;
        this.card.dataset.level = critical ? 'critical' : 'low';
        this.badge.textContent = critical ? d.labelCritical : d.labelLow;
        this.renderText(v.q);

        if (this.fill) {
          const pct = Math.max(8, Math.min(100, (v.q / d.threshold) * 100));
          this.fill.style.width = `${pct}%`;
        }

        if (this.card.hidden) this.card.hidden = false;
      }
    }

    customElements.define('low-stock', LowStock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('price-discount')) {
    class PriceDiscount extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-discount-json]');
        if (!json) return;
        try {
          this.data = JSON.parse(json.textContent);
        } catch (err) {
          console.error('price-discount: JSON inválido', err);
          return;
        }

        this.label = this.querySelector('[data-discount-text]');
        this.section = this.closest('.shopify-section') || document;

        this.onVariant = (e) => this.update(e?.detail?.resource?.id);
        this.onChange = () => {
          requestAnimationFrame(() => this.update());
          setTimeout(() => this.update(), 350);
        };

        document.addEventListener('variant:update', this.onVariant);
        this.section.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
        this.section?.removeEventListener('change', this.onChange);
      }

      currentId() {
        return Number(
          this.section.querySelector('form input[name="id"]')?.value ||
          new URL(location.href).searchParams.get('variant')
        );
      }

      update(id) {
        const variantId = Number(id) || this.currentId();
        const entry = this.data.variants[variantId];
        if (!entry) return;

        const [price, compare] = entry;
        const pct = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;

        if (pct <= 0) {
          if (!this.hidden) this.hidden = true;
          return;
        }

        const text = this.data.format.replace('{pct}', pct);
        if (this.label.textContent !== text) this.label.textContent = text;
        if (this.hidden) this.hidden = false;
      }
    }

    customElements.define('price-discount', PriceDiscount);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-claims"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-claims')) {
    class ProductClaims extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.sync());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.go(i);
            this.start();
          });
        });

        this.delay = (Number(this.dataset.autoplay) || 0) * 1000;
        if (this.delay && !this.reduced) {
          ['pointerenter', 'focusin', 'touchstart'].forEach((ev) =>
            this.addEventListener(ev, () => this.stop(), { passive: true })
          );
          ['pointerleave', 'focusout', 'touchend'].forEach((ev) =>
            this.addEventListener(ev, () => this.start(), { passive: true })
          );
          this.start();
        }
      }

      disconnectedCallback() {
        this.stop();
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      isCarousel() {
        return getComputedStyle(this.track).display === 'flex';
      }

      setActive(i) {
        this.index = i;
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      }

      sync() {
        const w = this.track.clientWidth;
        if (!w) return;
        const i = Math.round(this.track.scrollLeft / w);
        if (i !== this.index) this.setActive(i);
      }

      go(i) {
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        this.setActive(next);
        this.track.scrollTo({
          left: next * this.track.clientWidth,
          behavior: this.reduced ? 'auto' : 'smooth'
        });
      }

      start() {
        this.stop();
        if (!this.delay) return;
        this.timer = setInterval(() => {
          if (this.isCarousel() && !document.hidden) this.go(this.index + 1);
        }, this.delay);
      }

      stop() {
        clearInterval(this.timer);
      }
    }

    customElements.define('product-claims', ProductClaims);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-sizes')) {
    class DeliverySizes extends HTMLElement {
      connectedCallback() {
        this.picker = this.querySelector('[data-picker]');
        this.box = this.querySelector('[data-delivery-msg]');
        if (!this.picker || !this.readData()) return;

        this.queued = false;
        this.waitVariant = null;
        this.waitStart = 0;
        this.boxState = null;
        this.schedule = this.schedule.bind(this);
        this.run = this.run.bind(this);
        this.onPress = this.onPress.bind(this);
        this.restoreBox = this.restoreBox.bind(this);

        // Selector: cambios de selección y marcas nuestras que Horizon borra al re-renderizar
        this.pickerObserver = new MutationObserver(this.schedule);
        this.pickerObserver.observe(this.picker, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: [
            'checked',
            'class',
            'aria-checked',
            'selected',
            'hidden',
            'data-delivery',
            'data-size-group',
            'data-size-list',
            'data-ds-single'
          ]
        });

        // Tarjeta de envío: si Horizon la resetea, se restaura al instante con el último estado
        this.boxObserver = new MutationObserver(this.restoreBox);
        if (this.box) {
          this.boxObserver.observe(this.box, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['hidden', 'data-speed']
          });
        }

        // Instantáneo al pulsar una talla; recálculo completo al confirmarse el cambio
        this.picker.addEventListener('pointerdown', this.onPress, { passive: true });
        this.picker.addEventListener('change', this.run);
        document.addEventListener('variant:update', this.schedule);

        // Guía de tallas
        this.addEventListener('click', (e) => {
          const dialog = this.querySelector('[data-size-guide]');
          if (!dialog) return;
          if (e.target.closest('[data-open-guide]')) {
            e.preventDefault();
            dialog.showModal();
          } else if (e.target.closest('[data-close-guide]') || e.target === dialog) {
            dialog.close();
          }
        });

        this.run();
      }

      disconnectedCallback() {
        this.pickerObserver?.disconnect();
        this.boxObserver?.disconnect();
        clearTimeout(this.retryTimer);
        this.picker?.removeEventListener('pointerdown', this.onPress);
        this.picker?.removeEventListener('change', this.run);
        document.removeEventListener('variant:update', this.schedule);
      }

      // Lee los datos una sola vez; solo vuelve a leerlos si el servidor los cambia
      readData() {
        const json = this.querySelector('[data-delivery-json]');
        if (!json) return false;
        const text = json.textContent;
        if (this.data && text === this.jsonText) return true;
        try {
          this.data = JSON.parse(text);
          this.jsonText = text;
          if (!this.fmt) {
            this.fmt = new Intl.DateTimeFormat(this.data.locale || 'es-ES', { day: 'numeric', month: 'short' });
          }
          // Qué opciones tienen más de un valor (las de un solo valor se dan por sabidas)
          const variants = this.data.variants;
          const count = variants[0]?.options.length || 0;
          this.multi = Array.from({ length: count }, (_, i) => new Set(variants.map((v) => v.options[i])).size > 1);
          return true;
        } catch (err) {
          console.error('delivery-sizes: JSON inválido', err);
          return false;
        }
      }

      // Como mucho un recálculo por fotograma, aunque Horizon haga muchos cambios seguidos
      schedule() {
        if (this.queued) return;
        this.queued = true;
        requestAnimationFrame(this.run);
      }

      run() {
        this.queued = false;
        if (!this.readData()) return;
        this.apply();

        // Descarta los avisos generados por nuestros propios cambios (evita bucles)
        this.pickerObserver?.takeRecords();
        this.boxObserver?.takeRecords();
      }

      // Horizon ha tocado la tarjeta de envío: se repinta el último estado, sin recalcular nada
      restoreBox() {
        if (this.boxState) this.paintBox(this.boxState);
        this.boxObserver?.takeRecords();
      }

      // Al pulsar una talla: muestra su plazo sin esperar al clic completo ni al tema
      onPress(e) {
        const label = e.target instanceof Element ? e.target.closest('label') : null;
        if (!label || !this.picker.contains(label)) return;

        const input = label.querySelector('input[type="radio"]') ||
          (label.htmlFor ? document.getElementById(label.htmlFor) : null);
        if (!input || input.disabled) return;

        const map = this.groupMap();
        const index = map.findIndex((g) => g && g.contains(input));
        if (index < 0) return;

        const sel = this.selection(map);
        sel[index] = input.value;
        if (!this.isComplete(sel)) return;

        const v = this.find(sel);
        if (!v) return;

        this.showVariant(v);
        this.pickerObserver?.takeRecords();
      }

      // Solo las opciones reales del producto: fuera apps de swatches y fieldsets sin radios
      groups() {
        return [...this.picker.querySelectorAll('fieldset, select')].filter((el) => {
          if (el.closest('variant-swatch-king, .swatches')) return false;
          if (el.tagName === 'SELECT') return !el.closest('fieldset');
          return !!el.querySelector('input[type="radio"]');
        });
      }

      // Cada selector colocado en la posición real de su opción (Talla, Color…)
      groupMap() {
        const map = [];
        this.groups().forEach((g, i) => {
          const raw = g.dataset.fieldsetIndex ?? g.querySelector('[data-fieldset-index]')?.dataset.fieldsetIndex;
          const idx = raw != null && raw !== '' ? Number(raw) : i;
          map[Number.isFinite(idx) ? idx : i] = g;
        });
        return map;
      }

      readValue(group) {
        if (group.tagName === 'SELECT') return group.value;
        return group.querySelector('input[type="radio"]:checked')?.value ?? null;
      }

      // Selección por posición de opción; las que no tienen selector quedan en null
      selection(map) {
        const count = this.data.variants[0]?.options.length || 0;
        const sel = new Array(count).fill(null);
        map.forEach((g, i) => {
          if (g && i < count) sel[i] = this.readValue(g);
        });
        return sel;
      }

      // Completa si todas las opciones con varios valores están elegidas
      isComplete(sel) {
        return sel.every((value, i) => value != null || !this.multi[i]);
      }

      find(sel) {
        return this.data.variants.find((v) =>
          v.options.every((o, i) => sel[i] == null || sel[i] === o)
        );
      }

      // Variante actual a partir de lo marcado (sin esperar al formulario de Horizon)
      current() {
        const sel = this.selection(this.groupMap());
        if (this.isComplete(sel)) {
          const v = this.find(sel);
          if (v) return v;
        }

        const variants = this.data.variants;
        const section = this.closest('.shopify-section') || document;
        const id = Number(
          section.querySelector('form input[name="id"]')?.value ||
          new URL(location.href).searchParams.get('variant')
        );
        return variants.find((v) => v.id === id) || variants[0];
      }

      labelFor(input) {
        return input.closest('label') ||
          (input.id ? this.picker.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null);
      }

      // Contenedor real de los botones: ancestro común de la primera y la última talla
      sizeList(group) {
        const inputs = group.querySelectorAll('input[type="radio"]');
        if (!inputs.length) return group;
        const first = this.labelFor(inputs[0]) || inputs[0];
        const last = this.labelFor(inputs[inputs.length - 1]) || inputs[inputs.length - 1];
        let node = first.parentElement;
        while (node && node !== group && !node.contains(last)) node = node.parentElement;
        return node && group.contains(node) ? node : group;
      }

      decorate(map) {
        const sizeGroup = map[this.data.sizeIndex];
        const valid = sizeGroup && sizeGroup.tagName === 'FIELDSET' ? sizeGroup : null;
        const list = valid ? this.sizeList(valid) : null;

        // Limpieza: nada de marcas ni cabeceras fuera del grupo de tallas
        this.picker.querySelectorAll('[data-size-group]').forEach((el) => {
          if (el !== valid) el.removeAttribute('data-size-group');
        });
        this.picker.querySelectorAll('[data-size-list]').forEach((el) => {
          if (el !== list) el.removeAttribute('data-size-list');
        });
        this.picker.querySelectorAll('[data-size-head]').forEach((el) => {
          if (!valid || !valid.contains(el)) el.remove();
        });

        if (!valid) return null;
        if (!valid.hasAttribute('data-size-group')) valid.setAttribute('data-size-group', '');
        if (!list.hasAttribute('data-size-list')) list.setAttribute('data-size-list', '');

        let head = valid.querySelector('[data-size-head]');

        // Si la cabecera quedó dentro de un contenedor interno de botones, la sacamos
        if (head && list !== valid && list.contains(head)) list.before(head);

        if (!head) {
          const tpl = this.querySelector('template[data-size-head-tpl]');
          head = tpl?.content.firstElementChild?.cloneNode(true);
          if (head) {
            if (list !== valid) {
              list.before(head);
            } else {
              const legend = valid.querySelector(':scope > legend');
              legend ? legend.after(head) : valid.prepend(head);
            }
          }
        }
        return valid;
      }

      // Oculta selectores con un solo valor (nunca la talla)
      hideSingles(map) {
        const sizeIndex = this.data.sizeIndex;
        const sizeGroup = map[sizeIndex];
        map.forEach((g, i) => {
          if (!g) return;
          let target = g.closest('.variant-option') || g;
          if (sizeGroup && target !== g && target.contains(sizeGroup)) target = g;

          const count = g.tagName === 'SELECT'
            ? g.options.length
            : g.querySelectorAll('input[type="radio"]').length;
          const hide = this.data.hideSingle && i !== sizeIndex && count <= 1;

          if (hide && !target.hasAttribute('data-ds-single')) target.setAttribute('data-ds-single', '');
          if (!hide && target.hasAttribute('data-ds-single')) target.removeAttribute('data-ds-single');
        });
      }

      // Stock solo en sucursal de marca: disponible, no en reserva y 0 en *Cacles
      isBrand(v) {
        return Boolean(v && v.available && !v.preorder && v.w === 0);
      }

      // Lenta = reserva (Timesact) o stock solo en sucursal de marca
      speedOf(v) {
        if (!v || !v.available) return '';
        return v.preorder || this.isBrand(v) ? 'slow' : 'fast';
      }

      apply() {
        const { sizeIndex } = this.data;
        const map = this.groupMap();
        const sel = this.selection(map);
        const sizeGroup = this.decorate(map);
        this.hideSingles(map);
        let anySlow = false;

        if (sizeIndex >= 0 && map[sizeIndex]) {
          map[sizeIndex].querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = this.labelFor(input);
            if (!label) return;
            const candidate = [...sel];
            candidate[sizeIndex] = input.value;
            const speed = this.speedOf(this.find(candidate));
            if (speed === 'slow') anySlow = true;
            if ((label.dataset.delivery || '') !== speed) {
              if (speed) label.dataset.delivery = speed;
              else delete label.dataset.delivery;
            }
          });
        }

        const legend = sizeGroup?.querySelector('[data-legend]');
        if (legend && legend.hidden !== !anySlow) legend.hidden = !anySlow;

        this.showVariant(this.current());
      }

      clean(text) {
        return (text || '').replace(/^\s*disponibilidad\s*:\s*/i, '').trim();
      }

      // Respaldo: texto pintado por Timesact en la página
      appText() {
        const selector = '.timesact-preorder-description, [class*="timesact"][class*="description"]';
        const pools = [this.closest('.shopify-section'), document].filter(Boolean);
        for (const pool of pools) {
          for (const el of pool.querySelectorAll(selector)) {
            if (this.contains(el)) continue;
            const text = this.clean(el.textContent);
            if (text) return text;
          }
        }
        return '';
      }

      // Fechas dentro de un texto, en orden: "13 de octubre de 2026", "13 oct", "13/10/2026"
      findDates(raw) {
        const months = {
          ene: 0, enero: 0, feb: 1, febrero: 1, mar: 2, marzo: 2, abr: 3, abril: 3, may: 4, mayo: 4,
          jun: 5, junio: 5, jul: 6, julio: 6, ago: 7, agosto: 7, sep: 8, sept: 8, set: 8, septiembre: 8,
          setiembre: 8, oct: 9, octubre: 9, nov: 10, noviembre: 10, dic: 11, diciembre: 11
        };
        const year = new Date().getFullYear();
        const found = [];
        let m;

        const named = /(\d{1,2})\s+(?:de\s+)?([a-z]{3,10})\.?(?:\s+(?:de\s+)?(\d{4}))?/gi;
        while ((m = named.exec(raw))) {
          const month = months[m[2].toLowerCase()];
          if (month == null) continue;
          found.push({ at: m.index, date: new Date(m[3] ? Number(m[3]) : year, month, Number(m[1])) });
        }

        const numeric = /\b(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})\b/g;
        while ((m = numeric.exec(raw))) {
          const month = Number(m[2]) - 1;
          if (month < 0 || month > 11) continue;
          const y = Number(m[3]) < 100 ? 2000 + Number(m[3]) : Number(m[3]);
          found.push({ at: m.index, date: new Date(y, month, Number(m[1])) });
        }

        return found
          .filter((f) => !Number.isNaN(f.date.getTime()))
          .sort((a, b) => a.at - b.at)
          .slice(0, 2)
          .map((f) => f.date);
      }

      // "envío 6 de octubre de 2026 - 12 de octubre de 2026" → "Se envía entre el 6 oct y el 12 oct"
      // Sin fecha (p. ej. "Pre-order Froddo AW26") devuelve vacío: nunca se enseña el nombre del plan
      formatPreorder(raw) {
        if (!raw) return '';
        const dates = this.findDates(raw);
        if (!dates.length) return '';

        const from = this.fmt.format(dates[0]);
        const to = this.fmt.format(dates[dates.length - 1]);
        const tpl = from === to ? this.data.preorderSingle : this.data.preorderRange;
        return tpl.replace('{min}', from).replace('{max}', to).replace('{date}', to);
      }

      // Texto del plan de venta de la variante (nombre + descripción + opciones)
      planText(v) {
        const plans = this.data.plans || {};
        return v && v.sp ? plans[v.sp] || '' : '';
      }

      setText(node, text) {
        if (node && node.textContent !== text) node.textContent = text;
      }

      updateStock(v) {
        const el = this.picker.querySelector('[data-size-group] [data-stock]');
        if (!el) return;
        const d = this.data;
        const qty = Number(v?.q);
        let text = '';

        if (v && !v.available && d.soldOutOn) {
          text = d.soldOutText;
        } else if (d.lowStockOn && v && v.available && v.t && qty > 0 && qty <= d.lowStockMax) {
          const tpl = qty === 1 ? d.lowStockOne : d.lowStockMany;
          text = tpl.replace('{qty}', qty);
        }

        if (!text) {
          if (!el.hidden) el.hidden = true;
          return;
        }

        this.setText(el, text);
        if (el.hidden) el.hidden = false;
      }

      // Reserva: fecha del plan de venta → fecha del texto de Timesact en la página → respaldo
      preorderMessage(v) {
        const planText = this.formatPreorder(this.clean(this.planText(v)));
        if (planText) {
          clearTimeout(this.retryTimer);
          return planText;
        }

        const pageText = this.formatPreorder(this.appText());
        if (pageText) {
          clearTimeout(this.retryTimer);
          return pageText;
        }

        if (this.waitVariant !== v.id) {
          this.waitVariant = v.id;
          this.waitStart = Date.now();
        }

        if (Date.now() - this.waitStart < 4000) {
          clearTimeout(this.retryTimer);
          this.retryTimer = setTimeout(this.schedule, 400);
          return this.data.preorderHint;
        }

        return this.data.preorderFallback;
      }

      // Calcula el estado de la tarjeta de envío y lo pinta
      showVariant(v) {
        this.updateStock(v);
        if (!this.box) return;

        let state;
        if (!v || !v.available) {
          state = { hidden: true };
        } else {
          const d = this.data;
          let text;
          if (v.preorder) {
            text = this.preorderMessage(v);
          } else {
            this.waitVariant = null;
            clearTimeout(this.retryTimer);
            text = this.isBrand(v)
              ? this.estimate(d.brandMin, d.brandMax, d.preorderRange, d.preorderSingle)
              : this.estimate(d.stockMin, d.stockMax, d.template, d.templateSingle);
          }

          const speed = this.speedOf(v);
          const size = d.sizeIndex >= 0 ? v.options[d.sizeIndex] : null;
          state = {
            hidden: false,
            speed,
            badge: speed === 'slow' ? d.labelSlow : d.labelFast,
            size: size ? `${d.sizeLabel} ${size} ·` : '',
            text
          };
        }

        this.boxState = state;
        this.paintBox(state);
        this.boxObserver?.takeRecords();
      }

      // Pinta un estado ya calculado (solo toca lo que ha cambiado)
      paintBox(state) {
        if (state.hidden) {
          if (!this.box.hidden) this.box.hidden = true;
          return;
        }
        if (this.box.dataset.speed !== state.speed) this.box.dataset.speed = state.speed;
        this.setText(this.box.querySelector('[data-badge]'), state.badge);
        this.setText(this.box.querySelector('[data-size]'), state.size);
        this.setText(this.box.querySelector('[data-text]'), state.text);
        if (this.box.hidden) this.box.hidden = false;
      }

      isWeekend(d) {
        const day = d.getDay();
        return day === 0 || day === 6;
      }

      addBusinessDays(date, n) {
        const d = new Date(date);
        let added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (!this.isWeekend(d)) added++;
        }
        return d;
      }

      estimate(min, max, tplRange, tplSingle) {
        const lo = Math.min(min, max);
        const hi = Math.max(min, max);
        let base = new Date();
        const hour = Number(
          new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour: 'numeric', hourCycle: 'h23' }).format(base)
        );
        if (this.isWeekend(base) || hour >= this.data.cutoff) base = this.addBusinessDays(base, 1);

        const from = this.fmt.format(this.addBusinessDays(base, lo));
        const to = this.fmt.format(this.addBusinessDays(base, hi));
        const tpl = from === to ? tplSingle : tplRange;
        return tpl.replace('{min}', from).replace('{max}', to).replace('{date}', to);
      }
    }

    customElements.define('delivery-sizes', DeliverySizes);
  }
  } catch(e) { console.error(e); }
})();

})();
